import dayjs from "dayjs";
import { ClosedSearchParams } from "../Models/ClosedSearchParams";
import utc from "dayjs/plugin/utc";

export function formatDateString(date: Date, formatType: string) {
    if (date instanceof Date && !isNaN(date as any)) {
        const dd = String("0" + (date.getDate())).slice(-2);
        const mm = String("0" + (date.getMonth() + 1)).slice(-2);
        const yyyy = date.getFullYear();
        if(formatType === 'mm/dd/yyyy') {
            return `${mm}/${dd}/${yyyy}`;
        } else if(formatType === 'yyyy-mm-dd') {
            return `${yyyy}-${mm}-${dd}`;
        } else {
            return 'Invalid Format';
        }
    } else {
        return 'Invalid Date';
    }
  };

  export function parseDateFromSlashFormat(dateStr: string): Date | null {
    const [month, day, year] = dateStr.split('/').map(Number);
    if (!month || !day || !year || isNaN(month) || isNaN(day) || isNaN(year)) return null;
    return new Date(year, month - 1, day);
  };

  export function convertOTSFromToUTCDateTime(otsFrom: string, otsTo: string): { fromUTC: string, toUTC: string } {
    let fromUTC = '';
    let toUTC = '';
    let fromDate = parseDateFromSlashFormat(otsFrom);
    let toDate = parseDateFromSlashFormat(otsTo);

    if (fromDate) {
        fromDate.setHours(0, 0, 0, 0);
        fromUTC = fromDate.toISOString();
    }
    if (toDate) {
        toDate.setHours(23, 59, 59, 999);
        toUTC = toDate.toISOString();
    }

    return { fromUTC, toUTC };
  };

  export function convertClosedSearchParamsForApiCall(search: ClosedSearchParams): ClosedSearchParams {
    let updatedSearchParams = { ...search };
    updatedSearchParams.aircraftRegistration = updatedSearchParams.aircraftRegistration ? 'N' + updatedSearchParams.aircraftRegistration : '';
    const { fromUTC, toUTC } = convertOTSFromToUTCDateTime(updatedSearchParams.outOfServiceTimeStart, updatedSearchParams.outOfServiceTimeEnd);
    updatedSearchParams.outOfServiceTimeStart = fromUTC;
    updatedSearchParams.outOfServiceTimeEnd = toUTC;

    return updatedSearchParams;
  }

//finds if the given date time is in past, within 5 mins, same day in future, next days in future
  export function findTimeDifferenceForAdvEtr(currentTime: Date, eventTimeUTC: string):  { timeDiffStatus: string; diffInDays?: number } {
    const eventTime = new Date(eventTimeUTC);
    const timeDiff = eventTime.getTime() - currentTime.getTime();
    const diffInMinutes = Math.ceil(timeDiff / (1000 * 60));

    if (timeDiff <= 0) {
        return { timeDiffStatus: "overdue" }; // Event time is in the past
    } else if (diffInMinutes <= 5) {
        return { timeDiffStatus: "within-5-mins" }; // Event time is within the next 5 minutes
    } else if (
        eventTime.getFullYear() === currentTime.getFullYear() &&
        eventTime.getMonth() === currentTime.getMonth() &&
        eventTime.getDate() === currentTime.getDate()
    ) {
        return { timeDiffStatus: "today" }; // Event time is on the same day in local time
    } else {
        const currentDate = new Date(
            currentTime.getFullYear(),
            currentTime.getMonth(),
            currentTime.getDate()
        );
        const eventDate = new Date(
            eventTime.getFullYear(),
            eventTime.getMonth(),
            eventTime.getDate()
        );
        const diffInDays = Math.ceil(
            (eventDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)
          );
        return { timeDiffStatus: "future-day", diffInDays}; // Event time is on a future day
    }
  }

  //finds etd time difference in days if etd in future
  export function findTimeDifferenceForEtd(currentTime: Date, eventTime: string): { diffInDays: number } {
    const eventDate = new Date(eventTime);
    const localEventDate = new Date(
        eventDate.getFullYear(),
        eventDate.getMonth(),
        eventDate.getDate()
    );
    const currentDate = new Date(
        currentTime.getFullYear(),
        currentTime.getMonth(),
        currentTime.getDate()
    );

    // Calculate the difference in days
    const diffInDays = Math.ceil(
        (localEventDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    return { diffInDays: diffInDays > 0 ? diffInDays : 0 };
}

  //format the given date time to local time 
  export function formatDateTimeToLocalTime(dateTime: string) {
    dayjs.extend(utc);
    const convertedTime = dayjs.utc(dateTime).local();
    return {
        time: convertedTime.format("HH:mm"), 
        date: convertedTime.format("MM/DD/YY")
    };
  }

  export function formatDateTime(dateTime: string) {
    const convertedTime = dayjs(dateTime);
    return {
        time: convertedTime.format("HH:mm"), 
        date: convertedTime.format("MM/DD/YY")
    };
  }

  export function getSortCode(key: string, sortOrder: "asc" | "desc" ) {
    if (key === "Hours Open"){
        return sortOrder === "asc" ? 2 : 1;
    }
    return sortOrder === "asc" ? 1 : 2;
  }

  export function getSortOrder(key: string, sortCode: string) {
    if (key === "Hours Open"){
        return sortCode === "2" ? "asc" : "desc";
    }
    return sortCode === "1" ? "asc" : "desc";
  }